import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/brand-logos/desktop-dark.png")